import React from 'react';
import { Card } from "../../tailwind/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tailwind/select";
import { Smartphone } from "lucide-react";

export const SendFromSelector = ({ phones, selectedSender, onSenderChange }) => {
  return (
    <Card className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-semibold text-sm">1</div>
        <h3 className="font-semibold text-gray-900 dark:text-white">Send From</h3>
      </div>

      <div className="space-y-1">
        <label className="text-gray-600 text-sm">Select Connected WhatsApp Number</label>
        <Select value={selectedSender} onValueChange={onSenderChange}>
          <SelectTrigger className="w-full h-14 bg-gray-50 dark:bg-slate-900 text-gray-900 dark:text-white border border-gray-200 dark:border-slate-800">
            <SelectValue placeholder="Select sender number..." />
          </SelectTrigger>
          <SelectContent className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded-md shadow-lg">
            {phones.map((num) => (
              <SelectItem key={num.id} value={String(num.id)} className="py-3 hover:bg-gray-100 dark:hover:bg-slate-800">
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 rounded-lg bg-green-100 flex items-center justify-center flex-shrink-0">
                    <Smartphone className="h-4 w-4 text-green-700" />
                  </div>
                  <div className="flex flex-col text-left">
                    <span className="font-medium text-gray-900 dark:text-white">{num.label || num.displayName || 'WhatsApp'}</span>
                    <span className="text-xs text-gray-500 dark:text-slate-400">{num.number || num.displayPhoneNumber}</span>
                  </div>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </Card>
  );
};
